import React from 'react';

import { Result } from 'antd';
import { ResultStatusType } from 'antd/es/result';

import { FluxStatusDtoStatusEnum } from 'lib_api/lib/api/gen';

import './FluxStatusIcon.less';

const getResultStatusFromDto = (
  status: FluxStatusDtoStatusEnum,
): ResultStatusType => {
  switch (status) {
    case FluxStatusDtoStatusEnum.SUCCESS:
      return 'success';
    case FluxStatusDtoStatusEnum.ERROR:
      return 'error';
    case FluxStatusDtoStatusEnum.WARNING:
      return 'warning';
    default:
      throw new Error('Type of status not supported');
  }
};

interface FluxStatusProps {
  status: FluxStatusDtoStatusEnum;
}

export const statusLabels: Record<
  keyof typeof FluxStatusDtoStatusEnum,
  string
> = {
  SUCCESS: 'Succès',
  ERROR: 'Erreur',
  WARNING: 'Avertissement',
};

export const FluxStatusIcon = ({ status }: FluxStatusProps) => {
  return (
    <div
      className={`status-icon`}
      role="img"
      aria-label={`Statut: ${statusLabels[status]}`}
    >
      <Result className="icon-result" status={getResultStatusFromDto(status)} />
    </div>
  );
};
